import React from 'react';
import Toggle from 'material-ui/Toggle';
import './ToggleField.styl';

export default class ToggleField extends React.Component {
  handleToggle = (event, isInputChecked) => {
    this.props.onChange(isInputChecked);
  };

  render() {
    // eslint-disable-next-line
    let {onChange, onBlur, onError, value, ...extraProps} = this.props;

    value = value ? value : false;

    return (
      <Toggle
        className="ev-toggle-field"
        onToggle={this.handleToggle}
        onBlur={onBlur}
        toggled={value}
        labelPosition="right"
        {...extraProps}
      />
    );
  }
}
